import { useState } from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { usePageMeta } from "@/hooks/usePageMeta";
import Breadcrumb from "@/components/base/Breadcrumb";
import Pagination from "@/components/base/Pagination";
import ReviewCard from "@/components/base/ReviewCard";
import { reviews } from "@/mocks/reviews";
import { movies } from "@/mocks/movies";
import { getPopularReviews, paginate } from "@/utils/catalog";

export default function Reviews() {
  usePageMeta(
    "苍井空电影影评资讯 - 苍井空电影大全",
    "苍井空电影影评资讯页收录影迷撰写的长文影评、观后笔记与作品对照分析，每篇文章均关联具体影片资料，便于延伸阅读。",
  );
  const [page, setPage] = useState(1);
  const sorted = [...reviews].sort((a, b) => (a.date < b.date ? 1 : -1));
  const { items, totalPages, current } = paginate(sorted, page);
  const popular = getPopularReviews(5);

  return (
    <SiteLayout>
      <div className="mx-auto w-full max-w-[1320px] px-4 py-6 md:px-8 md:py-8">
        <Breadcrumb items={[{ label: "影评资讯" }]} />

        <header className="mt-5 border-b border-background-200 pb-6">
          <h1 className="font-heading text-2xl text-foreground-950 md:text-[32px]">苍井空电影影评资讯</h1>
          <p className="mt-2 max-w-3xl text-xs leading-relaxed text-foreground-600 md:text-[13px]">
            收录影迷撰写的长文影评、观后笔记与作品对照分析。每篇文章都关联具体作品，
            可以从文字回到资料页，也可以从资料页找到对应影评。
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-[11px] text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-article-line text-sm text-primary-500" />
              共 {reviews.length} 篇影评
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-user-3-line text-sm text-primary-500" />
              {new Set(reviews.map((review) => review.author)).size} 位作者
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line text-sm text-primary-500" />
              最近更新 2024 / 12 / 13
            </span>
          </div>
        </header>

        <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_300px]">
          <div className="min-w-0">
            <div className="flex items-center justify-between border-b border-background-200 pb-3">
              <h2 className="font-heading text-base text-foreground-950 md:text-lg">全部影评</h2>
              <span className="text-[11px] text-foreground-500">
                第 {current} / {totalPages} 页
              </span>
            </div>
            <div>
              {items.map((review) => (
                <ReviewCard key={review.id} review={review} variant="row" />
              ))}
            </div>
            <Pagination page={current} totalPages={totalPages} onChange={setPage} />
          </div>

          <aside className="space-y-4">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h2 className="font-heading text-base text-foreground-950">热门阅读</h2>
              <div className="mt-2">
                {popular.map((review) => (
                  <ReviewCard key={review.id} review={review} variant="mini" />
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100/70 p-5">
              <h2 className="font-heading text-base text-foreground-950">按作品浏览</h2>
              <ul className="mt-3 space-y-2 text-xs text-foreground-600">
                {movies.slice(0, 8).map((movie) => (
                  <li key={movie.id}>
                    <Link
                      to={`/detail/${movie.id}`}
                      className="flex items-center justify-between gap-3 transition-colors hover:text-primary-700"
                    >
                      <span className="truncate">{movie.title}</span>
                      <span className="shrink-0 text-foreground-400">{movie.year}</span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Link
                to="/category"
                className="mt-3 inline-flex items-center gap-1 text-xs text-primary-700 hover:text-primary-800"
              >
                查看全部作品
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <div className="rounded-lg border border-accent-200 bg-accent-50 p-5">
              <p className="flex items-center gap-2 text-[11px] tracking-[0.18em] text-accent-800">
                <i className="ri-quill-pen-line text-sm" />
                SUBMISSION
              </p>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                欢迎投稿影评。请通过反馈表单留下联系方式与文章主题，我们会在整理后回复。
              </p>
              <Link
                to="/about#feedback"
                className="mt-3 inline-flex items-center gap-1 text-xs text-primary-700 hover:text-primary-800"
              >
                前往反馈表单
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </SiteLayout>
  );
}